<template>
  <div class="footer row">
    <div class="w-full">
      <div v-if="showFooterContent" class="row">
        <div class="w-full border-bottom-1 py-4">
          <!-- CRM汎用独自対応 -->
          <!-- <div class="wovn-languages">
            <i><img src="https://cms.benefit-one.inc/sites/default/files/2023-02/wovn-icon%402x.png" alt="" width="28" height="28"></i>
            <span class="wovn-switch" data-value="ja">日本語</span>
            <span>|</span>
            <span class="wovn-switch" data-value="en">English</span>
          </div> -->
          <CMS
              contents_type="block_contents"
              location_code="BS_TOP_01_012-TOP_minibanner"
          />
        </div>
        <!-- CRM汎用独自対応 -->
        <!-- <div class="w-full p-4 sm:px-0 sm:border-none border-bottom-1">
          <div class="l-container m-auto">
            <div class="row -ml-3 -mr-3">
              <div class="float-left w-3/12 sm:w-1/2 p-3">
                <div class="show-img-1 bg-gray-300"></div>
              </div>
              <div class="float-left w-3/12 sm:w-1/2 p-3">
                <div class="show-img-2 bg-gray-300"></div>
              </div>
              <div class="float-left w-3/12 sm:w-1/2 p-3">
                <div class="show-img-3 bg-gray-300">
                  <div class="title">ベネフィット・ステーション公式アプリ</div>
                  <div class="img">
                    <img src="~@/assets/images/footer/bnr_20_2.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="float-left w-3/12 sm:w-1/2 p-3">
                <div class="show-img-4 bg-gray-300"></div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- <div v-if="showFooterContent" class="row">
        <div class="w-full border-bottom-1">
          <div class="l-footer__menu">
            <div class="l-footer__menu__inner">
              <ul class="l-footer__info__inner__serviceList">
                <template v-if="!isLogin">
                  <li>
                    <a @click="linkToHealthPortal">
                      <img src="https://cms.benefit-one.inc/sites/default/files/contents/top/logo_kenkopoint.jpg" alt="健康ポイント">
                    </a>
                  </li>
                  <li>
                    <a @click="linkToIncentivepoint">
                      <img src="https://cms.benefit-one.inc/sites/default/files/contents/top/logo_incentivepoint.jpg" alt="IC">
                    </a>
                  </li>
                  <li>
                    <a @click="linkToBopf">
                      <img src="https://cms.benefit-one.inc/sites/default/files/contents/top/logo_bpf.jpg" alt="BPF">
                    </a>
                  </li>
                </template>
                <template v-else>
                  <li v-if="subscriptions.find(el => el.boServiceCode === 'HP')">
                    <a @click="linkToHealthPortal">
                      <img src="https://cms.benefit-one.inc/sites/default/files/contents/top/logo_kenkopoint.jpg" alt="健康ポイント">
                    </a>
                  </li>
                  <li v-if="subscriptions.find(el => el.boServiceCode === 'IC')">
                    <a @click="linkToIncentivepoint">
                      <img src="https://cms.benefit-one.inc/sites/default/files/contents/top/logo_incentivepoint.jpg" alt="IC">
                    </a>
                  </li>
                  <li>
                    <a @click="linkToBopf">
                      <img src="https://cms.benefit-one.inc/sites/default/files/contents/top/logo_bpf.jpg" alt="BPF">
                    </a>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div> -->

      <div v-if="showFooterContent" class="row hidden">
        <div class="w-full p-4 border-bottom-1 pt-0 sm:px-0">
          <div class="l-container m-auto">
            <div class="row">
              <div class="w-3/4 sm:w-full float-left flex flex-col">
                <div class="row pt-4 pb-4 sm:pt-0">
                  <div class="w-full">
                    <label class="title" style="font-size: 16px">カテゴリ一覧</label>
                  </div>
                  <div class="float-left w-1/3 sm:w-1/2">
                    <div class="flex flex-col">
                      <!-- <a @click="goPath('https://bs.benefit-one.co.jp/bs/pages/bo/normal/station/gourmet/index.faces')" v-if="footerNo != 'men-02-030'">食べる</a> -->
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/normal/station/gourmet/index.faces'
                          )
                        "
                        v-if="footerNo != 'men-02-030'"
                        >食べる</a
                      >
                      <a v-if="footerNo == 'men-02-030'">旅</a>
                      <!-- hien dang lam url -->
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/normal/station/entame/index.faces'
                          )
                        "
                        v-if="footerNo != 'men-02-030'"
                        >遊ぶ</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/normal/station/shopping/index.faces'
                          )
                        "
                        v-if="footerNo == 'men-02-030'"
                        >買い物</a
                      >
                    </div>
                  </div>
                  <div class="float-left w-1/3 pl-2 sm:w-1/2">
                    <div class="flex flex-col">
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/normal/station/gourmet/index.faces'
                          )
                        "
                        v-if="footerNo == 'men-02-030'"
                        >食べる</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/normal/station/shopping/index.faces'
                          )
                        "
                        v-if="footerNo != 'men-02-030'"
                        >買い物</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/normal/station/ikuji/index.faces'
                          )
                        "
                        >育児・介護・健康</a
                      >
                    </div>
                  </div>
                  <div class="float-left w-1/3 sm:w-1/2 pl-3 sm:pl-0">
                    <div class="flex flex-col">
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/normal/station/entame/index.faces'
                          )
                        "
                        v-if="footerNo == 'men-02-030'"
                        >遊ぶ</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bs/srch/menuSrchGdgt.faces?category=012&keyword=&shopword=&areaword=&spcl=&bvp='
                          )
                        "
                        >その他</a
                      >
                    </div>
                  </div>
                  <div class="float-left w-3/12 sm:w-1/2">
                    <div class="flex flex-col"></div>
                  </div>
                </div>
                <div class="row w-full--16 sm:w-full border-bottom-1"></div>
                <div class="row pt-4 sm:hidden">
                  <div class="float-left w-1/3 sm:w-1/2">
                    <div class="flex flex-col">
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/special/'
                          )
                        "
                        >特集一覧</a
                      >
                      <a @click="goPath('https://pr.benefit-one.co.jp/bs/service/')"
                        >サービス・制度一覧</a
                      >
                    </div>
                  </div>
                  <div class="float-left w-1/3 pl-2 sm:w-1/2">
                    <div class="flex flex-col">
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/digital_book/'
                          )
                        "
                        >デジタルカタログ</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/special/monthly/202111/focus_index/index.html&bspr=bstop_focus'
                          )
                        "
                        >INDEX</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/special/monthly/202111/focus_index/index.html&bspr=bstop_focus'
                          )
                        "
                        >FOCUS</a
                      >
                    </div>
                  </div>
                  <div class="float-left w-1/3 sm:w-1/2 mt-auto sm:-mt-9 pl-3 sm:pl-0">
                    <div class="flex flex-col">
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bs/srch/menuPrticSrchRslt.faces?menuNo=733047'
                          )
                        "
                        >ベネフィットハンター</a
                      >
                      <a
                        @click="
                          goPath('https://corp.benefit-one.co.jp/work-style/neo-works/')
                        "
                        >Neoworks</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/monoliz/?bspr=top_campaign'
                          )
                        "
                        >Dリーグ</a
                      >
                    </div>
                  </div>
                  <div class="float-left w-1/3 sm:w-1/2">
                    <div class="flex flex-col"></div>
                  </div>
                </div>
                <div class="row pt-4 hidden sm:block">
                  <div class="float-left w-1/3 sm:w-1/2">
                    <div class="flex flex-col">
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/special/'
                          )
                        "
                        >特集一覧</a
                      >
                      <a @click="goPath('https://pr.benefit-one.co.jp/bs/service/')"
                        >サービス・制度一覧</a
                      >
                    </div>
                  </div>
                  <div class="float-left w-1/3 pl-2 sm:w-1/2">
                    <div class="flex flex-col">
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/digital_book/'
                          )
                        "
                        >ベネフィットハンター</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/special/monthly/202111/focus_index/index.html&bspr=bstop_focus'
                          )
                        "
                        >Neoworks</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/special/monthly/202111/focus_index/index.html&bspr=bstop_focus'
                          )
                        "
                        >Dリーグ</a
                      >
                    </div>
                  </div>
                  <div
                    class="float-left w-1/3 sm:w-1/2 mt-auto pl-3 sm:pl-0"
                    style="margin-top: -27px"
                  >
                    <div class="flex flex-col">
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/bs/pages/bs/srch/menuPrticSrchRslt.faces?menuNo=733047'
                          )
                        "
                        >デジタルカタログ</a
                      >
                      <a
                        @click="
                          goPath('https://corp.benefit-one.co.jp/work-style/neo-works/')
                        "
                        >INDEX</a
                      >
                      <a
                        @click="
                          goPath(
                            'https://bs.benefit-one.co.jp/monoliz/?bspr=top_campaign'
                          )
                        "
                        >FOCUS</a
                      >
                    </div>
                  </div>
                  <div class="float-left w-1/3 sm:w-1/2">
                    <div class="flex flex-col"></div>
                  </div>
                </div>
              </div>
              <div class="w-1/4 sm:w-full float-left pl-4 sm:pl-0">
                <div class="row -ml-4 -mr-4 pt-2">
                  <div class="w-full sm:w-1/2 px-4 pt-4 sm:pt-4 float-left">
                    <div class="box-1 flex items-center sm:flex-col sm:justify-center">
                      <div class="icon sm:text-center">
                        <i class="icon icon-bor-laptop"></i>
                      </div>
                      <div class="content">
                        <a class="text-black" href="/user-guide">ご利用ガイド</a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="w-full sm:w-1/2 px-4 sm:pl-2 sm:pr-4 pt-2 sm:pt-4 float-left"
                  >
                    <div class="box-1 flex items-center sm:flex-col sm:justify-center">
                      <div class="icon sm:text-center">
                        <i class="icon icon-bor-circle-question"></i>
                      </div>
                      <div class="content">
                        <a class="text-black" href="/faq">Q&A よくある質問</a>
                      </div>
                    </div>
                  </div>
                  <div class="w-full p-2 pr-4 flex items-center justify-end">
                    <span
                      ><a class="text-black" href="/bs-oth-01-001"
                        >フィードバックを送る</a
                      ></span
                    >
                    <div class="ml-2"><i class="icon icon-bor-arrow-right"></i></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showFooterContent" class="l-footer__menu">
        <div class="l-footer__menu__inner l-footer__menu__inner-bottom">
          <CMS
              contents_type="header_footer"
              view_area="footer"
          />
          <!--
          <div class="l-footer__menu-list">
            <div class="l-footer__menu-list__body">
            </div>
          </div>
          <div class="l-footer__menu-banner">
            <ul>
              <li class="l-footer__menu-banner__item">
                <CMS
                    contents_type="block_contents"
                    location_code="BS_TOP_01_013-TOP_form"
                />
              </li>
            </ul>
          </div>
          -->
        </div>
      </div>

      <div class="row">
        <div class="fixed-footer w-full flex justify-center items-center">
          ©{{ $moment().year() }} Benefit One Inc.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import CONST_DATA from "../../mixins/const/constData";

export default {
  name: 'special-footer',
  components: {
  },
  props: ['content'],
  data() {
    return {
      footerNo: this.$route.meta.footer,
      subscriptions: [],
    }
  },
  mounted() {
    this.getFromSiteCode();
  },
  methods: {
    linkToHealthPortal(){
      const link = process.env.VUE_APP_HLPT_URL
      window.open(link, '_blank')
    },
    linkToIncentivepoint(){
      const link = process.env.VUE_APP_ICPT_URL
      window.open(link, '_blank')
    },
    linkToBopf(){
      const link = process.env.VUE_APP_BOPF_URL
      window.open(link, '_blank')
    },
    goPath(path) {
      window.open(path)
    },
    gotoPath() {
      window.open('https://bs.benefit-one.co.jp/bs/pages/bs/top/top.faces')
    },
    getFromSiteCode() {
      const boCode = this.$store.getters["params/get"].boCode || 'CR';
      const companyCd = this.$store.getters["params/get"].companyCd
      return this.$repositories("user").contractInfo(boCode,companyCd)
          .then((res) => {
            const contractInfo = res.data.contractInfo;
            if(contractInfo.length > 0 ) {
              const subscriptions = contractInfo[0].subscriptions;
              this.subscriptions = subscriptions;
            }
          })
          .catch(() => {
            // TODO: エラー時の処理
          });
    },
  },
  computed: {
    footerContent() {
      return get(this.content, 'data[0].attributes.field_footer.value')
    },
    /**
     * フッターメニューの本体部分を表示するかどうかを判定する
     * @return {boolean} - フッターメニューの本体部分を表示するかどうか
     */
     showFooterContent() {
      if (typeof this.$route.meta.isShowFooterContent !== "boolean")
        return true;
      this.isShowFooterContent = this.$route.meta.isShowFooterContent;
      return this.isShowFooterContent;
    },
    isLogin() {
      if (this.$auth.loggedIn) return true;
      return false;
    },
  },
  watch: {
    $route() {
      this.footerNo = this.$route.meta.footer
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.wovn-languages {
  color: #73767A;
  display: flex!important;
  gap: 6px;
  justify-content: center;
  //margin-bottom: 10px;
}
.wovn-languages i {
  align-self: center;
  display: flex;
}
.wovn-languages img {
  display: inline-block;
  max-width: 14px;
  height: auto;

  &.wovn-icon {
    // SPにてnoneが指定されていることで言語切替アイコンが大きすぎる
    // そのためメディアクエリのデフォルトを詳細度で上書きをして回避している
    // PC側はもともとcontainなのでPC側に影響はない
    object-fit: contain;
  }
}
.wovn-languages .wovn-switch {
  cursor: pointer;
}
.wovn-switch:hover {
  color: #da291c;
}
.wovn-switch.selected {
  cursor: unset;
  color: #1F2021;
}
</style>
